<template>
  <div class="p_doc_box">
    <div class="topOperation">
        <div class="top-left">
            <div><ShowNavHead/></div>
        </div>
    </div>
    <div class="main-con">
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>知识库</el-breadcrumb-item>
                <el-breadcrumb-item>使用指南</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="p_doc_content">
            <div class="doc_box">
                <el-menu
                :default-active="activeIndex"
                @select="handleSelect"
                class="el-menu-doc"
                @open="handleOpen"
                @close="handleClose">
                <el-menu-item index="1">
                    <span slot="title">客服知识文档</span>
                </el-menu-item>
                <el-menu-item index="2">
                    <span slot="title">报表知识文档</span>
                </el-menu-item>
                    <!-- <el-submenu index="1">
                        <template slot="title">
                            <span>客服知识文档</span>
                        </template>
                        <el-menu-item-group>
                            <template slot="title">分组一</template>
                            <el-menu-item index="1-1">选项1</el-menu-item>
                            <el-menu-item index="1-2">选项2</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu> -->
                </el-menu>
                <div class="doc_box_table">
                    <el-table class="p_doc_table"
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column label="排序" width="60">
                            <template slot-scope="{row}">{{ row.indexNum }}</template>
                        </el-table-column>
                        <el-table-column label="标题">
                            <template slot-scope="{row}">
                                <a v-if="row.classify.indexOf('视频')>-1" class="txt01" @click="dtlVideoJump(row.indexNum)">{{ row.title }}</a>
                                <a v-if="row.title == '使用手册'" class="txt01" @click="dtlDocJump">{{ row.title }}</a>
                                <a v-if="row.title == '利润报表使用手册'" class="txt01" @click="dtlDocJump1">{{ row.title }}</a>
                                <a v-if="row.title == '利润报表使用手册1.0'" class="txt01" @click="dtlDocJump2">{{ row.title }}</a>
                                <div class="p_doc_txts">
                                    <div class="txt_item">
                                        <span>所属分类: {{ row.classify }}</span>
                                    </div>
                                    <div class="txt_item">
                                        <span>发布时间: {{ row.datetime }}</span>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="block" v-if="tableData.length>0">
                        <el-pagination
                            @current-change="changeBPage"
                            :current-page.sync="listQuery.currpage"
                            :page-size="listQuery.perpage"
                            @size-change="handleSizeChange"
                            :page-sizes="[10, 20, 50, 100]"
                            layout="total,sizes,prev,pager,next,jumper"
                            :total="total"
                        ></el-pagination>
                    </div>
                </div>
            </div>
            <!-- <el-collapse v-model="activeNames" @change="handleChange">
                <el-collapse-item title="1、系统使用手册" name="1">
                    <div title="点击可下载使用手册" @click="downloadHandle" class="txt03">客服使用手册</div>
                </el-collapse-item>
                <el-collapse-item title="2、系统使用视频" name="2">
                    <div title="点击可查看使用视频" @click="videoHandle" class="txt03">使用视频</div>
                </el-collapse-item>
            </el-collapse> -->
            <!-- <div class="doc_btn">
                <el-button type="success" size="small" @click="downloadHandle">下载操作手册</el-button>
            </div>-->
        </div>
    </div>
    <!-- 视频弹框 -->
    <!-- <el-dialog title="使用视频" :visible.sync="videoVisible" width="900px" class="cus_dialog" :show-close="false">
        <div class="class-video">
            <video id="video02" ref="myVideo" controls oncontextmenu="return false"  x5-video-player-type="h5-page" style="width:100%;max-height:500px;object-fit: scale-down;" webkit-playsinline="true" playsinline="true" poster="" controlslist="nodownload">
                <source src="https://jbimg.obs.cn-east-2.myhuaweicloud.com/helpfile/helpfile.mp4"
                type="video/mp4">
                Your browser does not support the video tag. 
            </video>
        </div>
      <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="closeHandle"
            size="small"
            >关闭</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
        listQuery:{
            currpage:1,
            perpage:10
        },
      tabPosition: 'left',
      tableData:[
        {
            indexNum:'1',
            auther:'', //作者
            department:'',//部门
            datetime:'2022-10-12',//发布时间
            classify:'客服使用视频',//所属分类
            title:'系统使用视频'
        },
        {
            indexNum:'2',
            auther:'',
            department:'',
            datetime:'2022-10-12',
            classify:'客服使用手册',
            title:'使用手册'
        },
        {
            indexNum:'3',
            auther:'',
            department:'',
            datetime:'2024-01-31',
            classify:'客服使用视频',
            title:'保险-商保(报增)流程2024-01-31'
        },
        {
            indexNum:'4',
            auther:'',
            department:'',
            datetime:'2024-01-31',
            classify:'客服使用视频',
            title:'保险-商保(报减)流程2024-01-31'
        },
        {
            indexNum:'5',
            auther:'',
            department:'',
            datetime:'2024-01-31',
            classify:'客服使用视频',
            title:'保险-商保(在保)查询2024-01-31'
        },
        {
            indexNum:'6',
            auther:'',
            department:'',
            datetime:'2024-05-30',
            classify:'客服使用视频',
            title:'(1-1花名册存量员工处理-步骤一)客户-存档花名册-导入2024-03-26'
        },
        {
            indexNum:'7',
            auther:'',
            department:'',
            datetime:'2024-05-30',
            classify:'客服使用视频',
            title:'(1-2花名册存量员工处理-步骤二)雇员-面试入职流程-花名册列表-在离职核对2024-04-03'
        },
        {
            indexNum:'8',
            auther:'',
            department:'',
            datetime:'2024-05-30',
            classify:'客服使用视频',
            title:'雇员-面试入职流程2024-05-30'
        },
        {
            indexNum:'9',
            auther:'',
            department:'',
            datetime:'2024-04-29',
            classify:'客服使用视频',
            title:'薪酬-算薪发薪流程2024-04-29'
        },
        {
            indexNum:'10',
            auther:'',
            department:'',
            datetime:'2024-05-31',
            classify:'客服使用视频',
            title:'薪酬-算薪核对流程2024-05-31'
        }
      ],
      activeIndex:'1',
      videoVisible:false,
      activeNames: ['1'],
      multipleSelection: [],
      total:0
    }
  },
  created() {
      this.total = this.tableData.length
  },
  methods: {
    handleOpen(key, keyPath) {
        console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
        console.log(key, keyPath);
    },
    handleSelect(key, keyPath){
        console.log('key', key);
        this.activeIndex = key
        if(key == '2'){
            this.tableData = [{
                indexNum:'1',
                auther:'', //作者
                department:'',//部门
                datetime:'2022-11-17',//发布时间
                classify:'使用手册',//所属分类
                title:'利润报表使用手册1.0'
            },
            {
                indexNum:'2',
                auther:'', //作者
                department:'',//部门
                datetime:'2022-11-08',//发布时间
                classify:'使用手册',//所属分类
                title:'利润报表使用手册'
            }
            ]
        }else{
            this.tableData = [
                {
                    indexNum:'1',
                    auther:'', //作者
                    department:'',//部门
                    datetime:'2022-10-12',//发布时间
                    classify:'客服使用视频',//所属分类
                    title:'系统使用视频'
                },
                {
                    indexNum:'2',
                    auther:'',
                    department:'',
                    datetime:'2022-10-12',
                    classify:'客服使用手册',
                    title:'使用手册'
                }
            ]
        }
        this.total = this.tableData.length
    },
    //分页
    changeBPage(val){
        this.listQuery.currpage = Number(val)
        // this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.currpage = 1
      this.listQuery.perpage = Number(val)
    //   this.getList()
    },
    handleSelectionChange(val){
        this.multipleSelection = val
    },
    videoHandle(){
        this.videoVisible = true
        this.$nextTick(() => {
            this.$refs.myVideo.pause()
        })
    },
    closeHandle(){
        this.videoVisible = false
        this.$refs.myVideo.pause()
    },
    handleChange(val) {
        console.log(val)
      },
      dtlVideoJump(num){
        this.$router.push({ 
            path: '/dtlVideo',
            query:{
                type: num
            }
        })
        // let { href } = this.$router.resolve({
        //     path: "/dtlVideo"
        // })
        // window.open(href, '_blank')
      },
      dtlDocJump(){
        this.$router.push({
        path: '/dtlDoc',
        query: {
            type:'custom'
        }
        })
        //   let { href } = this.$router.resolve({
        //     path: "/dtlDoc"
        // })
        // window.open(href, '_blank')
      },
       dtlDocJump1(){
        this.$router.push({
        path: '/dtlDoc',
        query: {
            type:'report',
            level:1
        }
        })
      },
       dtlDocJump2(){
        this.$router.push({
        path: '/dtlDoc',
        query: {
            type:'report',
            level:2
        }
        })
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.p_doc_content .el-menu-item.is-active{
    background-color: #ebfaf5;
    color:#19bd92;
}
.class-video,.class-video img {
    width: 100%;
}
.p_doc_content .el-tabs__item{
    height: 30px;
    line-height: 30px;
}
.p_doc_content .el-collapse{
    margin-top: 15px;
}
.p_doc_table .txt01{
    font-size: 14px;
    color:#333;
    cursor: pointer;
}
.p_doc_table .txt01:hover{
    color:#19bd92;
}
</style>
<style scoped>
.doc_box{
    display: flex;
}
.doc_box .el-menu-doc{
    width: 200px;
    margin-right: 20px;
}
.doc_box_table{
    flex: 1;
}
.p_doc_content .txt03{
    width: 60%;
    font-size: 14px;
    padding-left: 25px;
    color:#19bd92;
    cursor: pointer;
}
.p_doc_txts{
    display: flex;
    flex-wrap: wrap;
    font-size: 12px;
    color:#999;
}
.txt_item{
    margin-right: 15px;
}
.doc_btn{
    display: flex;
    justify-content: flex-end;
}
.class-video{
    max-height:800px;
}
.p_doc_content{
    min-height: 800px;
    padding: 20px;
    background-color: #fff;
}
.el-pagination{
  background-color: #fff;
}
</style>